import type { clientData } from '../types/interfaces';

export type ManagementListItem = Readonly<{ id: number; label: string }>;

/**
 * Texto a mostrar para gerencia en vistas de solo lectura.
 * Prioriza `management_label` del API; si no viene, resuelve por id contra el catálogo.
 */
export function getManagementDisplayLabel(
  info: Pick<clientData, 'management_id' | 'management_label'> | undefined,
  managements: ReadonlyArray<ManagementListItem>
): string {
  if (!info) return '—';
  const label = info.management_label?.trim();
  if (label) return label;
  const mid = info.management_id;
  if (mid === undefined || mid === null || mid === '') return '—';
  const n = typeof mid === 'number' ? mid : Number(mid);
  if (Number.isNaN(n)) return '—';
  return managements.find((m) => m.id === n)?.label ?? '—';
}
